import BadgeCard from './BadgeCard'

/**
 * Renders badges as big, bold pictorial cards: large emoji on top, then name and description.
 * Empty state when no badges.
 * When newBadgeIds (Set) is provided and badgeScope is set, badges in that set get a fly-in award animation.
 */
export default function BadgesList({
  badges = [],
  showCategory = false,
  emptyMessage = 'No badges yet.',
  newBadgeIds = null,
  badgeScope = null,
  onAwardAnimated,
  /** Number of new badges that animate before this list (for global sequential ordering). */
  awardDelayOffset = 0,
  /** When true, force all badges into a single row (no wrapping). */
  singleRow = false,
  /** When true, renders smaller badge cards (used in the dashboard header widget). */
  compact = false,
}) {
  const list = Array.isArray(badges) ? badges : []

  if (list.length === 0) {
    return (
      <p className={compact ? 'text-sm text-gray-400' : 'text-base text-gray-400'}>{emptyMessage}</p>
    )
  }

  const PAGE_LOAD_DELAY_S = 2.5
  const BADGE_DROP_DURATION_S = 2.5
  let awardIndex = 0
  const baseClass = compact ? 'flex gap-1.5' : 'flex gap-2 sm:gap-3'
  const wrapClass = singleRow ? 'flex-nowrap' : 'flex-wrap'
  const scrollClass = singleRow ? 'max-w-full overflow-x-auto pb-1' : ''

  return (
    <div className={`${baseClass} ${wrapClass} ${scrollClass}`}>
      {list.map((badge) => {
        const badgeKey = badge?.badgeKey ?? badge?.definition?.badgeKey ?? badge?.name
        const badgeId = badgeScope ? `${badgeScope}:${badgeKey}` : null
        const isNewAward = Boolean(
          newBadgeIds && badgeId && newBadgeIds.has(badgeId)
        )
        const delay = isNewAward
          ? PAGE_LOAD_DELAY_S + (awardDelayOffset + awardIndex++) * BADGE_DROP_DURATION_S
          : 0
        return (
          <BadgeCard
            key={badgeKey}
            badge={badge}
            isNewAward={isNewAward}
            awardDelay={delay}
            compact={compact}
            onAwardAnimated={isNewAward && onAwardAnimated ? () => onAwardAnimated(badgeId, badge) : undefined}
          />
        )
      })}
    </div>
  )
}
